import { useTranslation } from 'react-i18next';
import { Chip } from '@/ui';
import type { MemberType } from '@/auth/types';
import { translateMemberType } from './labels';

/**
 * Uye tipi rozeti — TEK cizim yeri.
 *
 * Etiket haritasi (MEMBER_TYPE_LABEL_KEYS) ekran koduna HIC girmiyor; ceviri
 * labels.ts icindeki `translateMemberType(t, ...)` uzerinden yapiliyor. Sebep:
 * harita METIN degil ANAHTAR tutar ve onu t() ile sarmayi unutan bir cagri yeri
 * ekranda ham anahtar basar (mobilde tam olarak boyle kirildi). Anahtarin hic
 * gorunmedigi bir arayuz, o hatanin yuzeyini tamamen kaldiriyor.
 */
export type MemberTypeChipProps = {
  memberType: MemberType | null;
  /** Uyelik pasifse tip yerine "Pasif" gosterilir. */
  inactive?: boolean;
};

export function MemberTypeChip({ memberType, inactive = false }: MemberTypeChipProps) {
  const { t } = useTranslation();

  if (inactive) return <Chip tone="neutral">{t('members.passive')}</Chip>;
  if (memberType === null) return null;

  const label = translateMemberType(t, memberType);
  if (label === null) return null;

  return <Chip tone={memberType === 'admin' ? 'primary' : 'info'}>{label}</Chip>;
}
